import gql from 'graphql-tag';

const getAccountPrintBackgrounds = gql`
  query getAccountPrintBackgrounds {
    me {
      id
      print_assets(print_asset_type: BACKGROUND, slice: { limit: 9999 }) {
        total
        records {
          id
          name
          asset_image {
            id
            url
            width
            height
          }
        }
      }
    }
  }
`;

export default getAccountPrintBackgrounds;
